// in memory of stupidity
const URL = 'https://test.cosmocareportal.com/api/v1';

export const checkEmail = async (email) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}auth/check_email/`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email: email })
    });
    const body = await response;
    return body;
  } catch (err) {
    throw Error(err.message);
  }
};


// WEBPACK FOOTER //
// ./src/api/index.js